export const LIST_ORDER_VN_ONE = 'LIST_ORDER_VN_ONE';
export const LIST_RECENT_ORDER = 'LIST_RECENT_ORDER';
export const FETCH_ORDER_VN_ONE = 'FETCH_ORDER_VN_ONE';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
